import React from 'react';

type Design = {
    categoryEntryInfo: string,
    projectDesignId: number,
}

interface WorkOriginDifferentiatorProps {
    design: Design;
}

export default class WorkOriginDifferentiator extends React.Component<WorkOriginDifferentiatorProps, {}> {

    render() {
        return  this.displayIfCreatedOn99d()
    }
    displayIfCreatedOn99d() {
        if (this.props.design.categoryEntryInfo || this.props.design.projectDesignId) {
            return (
                <div className="section">
                    <div className="sidebar-body">
                        <span className={'ddo__made-on-99-shield'}>Created on 99designs</span>
                    </div>
                </div>
            )
        }
        return null
    }
}



// WEBPACK FOOTER //
// ./src/js/apps/ddo/components/WorkOriginDifferentiator.tsx